module.exports = __webpack_public_path__ + "static/media/simplata.c665d91b.png";